const getStructuredLanguageList = (pageData, languageNames) => {
  if (!pageData || !languageNames) {
    return null;
  }
  const { localizations, locale } = pageData;
  const currentLanguageName = languageNames.find(item => item.code === locale)?.name || 'en';

  let localeValue = locale;
  if (locale === 'zh-Hant') {
    localeValue = 'zh_HANT';
  }
  const languagesList = {
    [localeValue]: {
      name: currentLanguageName,
      nativeName: currentLanguageName,
      value: localeValue,
    },
  };

  localizations?.forEach(item => {
    const languageName = languageNames.find(lt => lt.code === item.locale)?.name;

    let languageValue = item?.locale;
    if (item.locale === 'zh-Hant') {
      languageValue = 'zh_HANT';
    }
    if (languageName && languageValue) {
      languagesList[languageValue] = {
        name: languageName,
        nativeName: languageName,
        value: languageValue,
      };
    }
  });
  return languagesList;
};

export default getStructuredLanguageList;
